import moment from 'moment';
import classNames from 'classnames';

import ICS from './ics';

import * as api from '../../api';
import * as logger from '../../logger';
import { constructAddress } from '../../utils/practice';
import { getProviderNameFull } from '../../utils/provider';

import styles from './index.module.css';

interface Props extends React.PropsWithChildren {
  encounter: Pick<api.Encounter.Encounter, 'id' | 'startTime' | 'endTime'>;
  provider: api.User.UserIdentification | null;
  practice: Pick<
    api.Practice.Practice,
    'name' | 'address' | 'city' | 'state' | 'zip'
  >;
  subject?: string;
  description?: string;
  location?: string;
  className?: string;
}

const CalendarEvent: React.FC<Props> = ({
  subject,
  description,
  location,
  children,
  encounter,
  provider,
  practice,
  className,
}) => {
  let ics: ICS;
  try {
    ics = new ICS();
  } catch (err) {
    logger.error(err);
    return null;
  }
  const fullIdentifier = provider
    ? getProviderNameFull({ provider })
    : practice.name;
  const defaultDescription = `Appointment with ${fullIdentifier} ${moment(
    encounter.startTime,
  ).format('LLL')}`;
  const handleClick = () => {
    ics.addEvent({
      id: encounter.id,
      subject: subject || fullIdentifier,
      description: description || defaultDescription,
      location: location || constructAddress(practice),
      begin: encounter.startTime,
      stop:
        encounter.endTime ||
        moment(encounter.startTime).add(15, 'minutes').toDate(),
    });
    ics.download();
  };
  return (
    <span
      className={classNames(styles.Container, className)}
      onClick={handleClick}
    >
      {children}
    </span>
  );
};

export default CalendarEvent;
